/* eslint-disable eqeqeq */
import * as React from 'react';

import { Utils, getQueryString } from '@/utils/app';

import './index.less';

const { isiOS, isArd, handleClickInfoRep, jumpGameDetail, handleClickDownloadRep, getToActive} = Utils;

const icon = 'https://diy-assets.msstatic.com/game-release/rightArrow.png';

const isPreview = getQueryString('preview', '');

function GameInfo(props: any) {
  const { gameBaseInfo = {}, gameResourceInfo = {}, fromId, handTipsImgVis} = props;
  const { gameIcon, gameName, gameBrief, gameDownloadCount, noticeInfo, postStatus, reserveNum } = gameBaseInfo || {};
  const { adrDownloadUrl, iosDownloadUrl, adrFileSize } = gameResourceInfo || {};

  const getDownCount = () => {
    const count = postStatus === 2 ? reserveNum : gameDownloadCount;
    const unit = postStatus === 2 ? '预约' : '下载';
    if (!count) return null;
    if (count > 10000) {
      return `${(count / 10000).toFixed(1)}万${unit}`;
    } else {
      return `${count}${unit}`;
    }
  };

  const getRep = (obj: any) => {
    const newObj = {
      gamename: gameBaseInfo?.gameName,
      gameid: gameBaseInfo?.gameId,
      area: obj?.area,
    };
    handleClickInfoRep(newObj);
    jumpGameDetail({ gameId: gameBaseInfo?.gameId, fromId, toAction: getToActive(postStatus)}, handTipsImgVis);
  };

  const getPostStatusRep = () => {
    // 预览时阻止按钮点击
    if(isPreview != 0) return;

    let str = '';
    if (postStatus == 1) {
      str = 'downloadbutton';
    } else if (postStatus == 2) {
      str = 'orderbutton';
    } else if (postStatus == 3) {
      str = 'await';
    }
    const newObj = {
      gamename: gameBaseInfo?.gameName,
      gameid: gameBaseInfo?.gameId,
      area: str,
    };
    handleClickDownloadRep(newObj);
    jumpGameDetail({ gameId: gameBaseInfo?.gameId, fromId, toAction: getToActive(postStatus)}, handTipsImgVis);
  };

  const getText = () => {
    if (postStatus == 2) {
      return '预约';
    }
    if (postStatus == 3) {
      return '敬请期待';
    }
    if (postStatus == 1) {
      if (!!gameBaseInfo?.tGuideReserve?.sBtnLongText) {
        return gameBaseInfo?.tGuideReserve?.sBtnLongText;
      }
      return '下载';
    }
  };

  return (
    <>
      <div className='game-info-b'>
        <div className='game-info-w'>
          <img className='i-w-head-icon' src={gameIcon} alt='' />
          <div className='i-w-middling'>
            <span className='w-m-title'>{gameName}</span>
            <span className='w-m-desc'>{gameBrief}</span>
            <span className='w-m-desc'>{getDownCount()}</span>
          </div>
          <div className={`i-w-down status${postStatus}`} onClick={getPostStatusRep}>
            {getText()}
          </div>
        </div>
        {(noticeInfo.value || []).map((item: any, i: number) => (
          <div
            className='game-info-n'
            key={i}
            onClick={() => {
              getRep({ area: 'notice' });
            }}>
            <div className='i-n-left'>
              <span className='i-n-l-icon'>{item.tag || '公告'}</span>
              <span className='i-n-l-text'>{item.text}</span>
            </div>
            <img className='i-n-img' src={icon} alt='' />
          </div>
        ))}
      </div>
      <div className='down-a-w'>
        <div className={`d-a-w-btn status${postStatus}`} onClick={getPostStatusRep}>
          {getText()}
          {(postStatus == 1 &&  adrFileSize) ? (
            <span className='num'>
              {'('}
              {adrFileSize}
              {')'}
            </span>
          ) : null}
        </div>
      </div>
    </>
  );
}

export default GameInfo;
